import React from 'react'
import Subheader from '../../../component/Subheader'
import OtherRoom from '../../RoomDetail/OtherRoom';
import RoomBanner from '../../RoomDetail/RoomBanner';
import RoomQuote from '../../RoomDetail/RoomQuote';
import RoomCount from '../../RoomDetail/RoomCount';
import RoomGallery from '../../RoomDetail/RoomGallery';
import RoomEquipment from '../../RoomDetail/RoomEquipment';
import RoomBook from '../../RoomDetail/RoomBook';

export default function RishikeshPremium() {
    const heading = "Premium Suite";

    const subheadData = {
        heading: (
                    <>
                    <span className="sr-only">Rishikesh Room</span> {heading}
                    </>
                ),
        breadcrumb: [
            {
                slug: "/resort-de-coracao-rishikesh/room-listing",
                name: (
                        <>
                        <span className="sr-only">{heading}</span> Rooms
                        </>
                    ),
            },
            {
                slug: "",
                name: "Premium Suite",
            },
        ]
    }

    const roomBanner = {
        image: "/image/rishikesh-premium-suite-detail.webp",
    };

    const roomQuote = {
        content: "The Private Balcony Mountain View extends your living space, offering a refreshing spot to enjoy the surrounding views. Enhanced with premium amenities and generous room to unwind, the Premium Suite is ideal for couples, families, and travellers looking for luxury stays.",
    };

    const roomCount = {
        bedroom: "1",
        bedsize: "1 King",
        area: "30",
        bathroom: "1",
        guest: "3",
        balcony: "1"
    };

    const roomGallery = [
        { image: "/image/rishikesh-premium-suite-gallery-1.webp" },
        { image: "/image/rishikesh-premium-suite-gallery-2.webp" },
        { image: "/image/rishikesh-premium-suite-gallery-3.webp" },
        { image: "/image/rishikesh-premium-suite-gallery-4.webp" },
        // { image: "/image/rishikesh-premium-suite-gallery-1.webp" },
        // { image: "/image/corbett-premium-room-gallery-6.webp" },
    ];

    const roomEquipment = {
        description: "Designed to make you feel at ease, this room offers a comfortable setting with thoughtful facilities for a convenient stay.",
        equipment: [
        [
            "Premium Pocketed Spring Mattress",
            "Air Conditioning",
            "Complimentary High-Speed Wi-Fi",
            "Smart TV for Entertainment",
        ],
        [
            "Tea & Coffee Maker with Daily Replenishment",
            "Mini Bar for Refreshments",
            "Electronic In-Room Safe",
            "Writing Desk with Comfortable Chair",
        ],
        [
            "Hydropneumatic Shower with 24-Hour Hot Water",
            "Soft Cotton Linens and Plush Duvet",
            "Iron & Ironing Board",
            "Bathrobe & Slippers",
        ]
    ]
    };


    const roomBook = {
        location: "Rishikesh",
        title: "Premium Suite",
        desc: "Unwind in the Premium Suite at De Coracao Rishikesh, designed for guests seeking extra comfort and a refined stay. Enjoy spacious interiors, a private balcony, premium amenities, and a peaceful setting that makes every moment of your Rishikesh getaway more relaxing.",
        details: [
            "1 King Size Bed",
            "Up to 3 Guests",
            "30 sq.mt"
        ],
        enquireLink: "/contact-us",
        bookLink: "https://www.swiftbook.io/inst/#/home?propertyId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU=&JDRN=Y&RoomID=255031,255032,255033,255034,255035&ap=1&gsId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU="
    };


    const otherRoom = {
        slides: [
            {
                title: 'Super Deluxe',
                bg: '/image/rishikesh-super-deluxe-inner-img.webp',
                slug: '/resort-de-coracao-rishikesh/super-deluxe',
                details: [
                    "1 King Size Bed",
                    "Up to 4 Guests",
                    "26 sq.mt",
                ],
            },

            {
                title: 'Suite',
                bg: '/image/rishikesh-suite-inner-img.webp',
                slug: '/resort-de-coracao-rishikesh/suite',
                details: [
                    "1 King Size Bed",
                    "Up to 3 Guests",
                    "33 sq.mt",
                ],
            },

            {
                title: 'Ganga Suite',
                bg: '/image/rishikesh-ganga-suite-inner-img.webp',
                slug: '/resort-de-coracao-rishikesh/ganga-suite',
                details: [
                    "1 King Size Bed",
                    "Up to 3 Guests",
                    "37 sq.mt",
                ],
            },
            {
                title: 'Deluxe',
                bg: '/image/rishikesh-deluxe-inner-img.webp',
                slug: '/resort-de-coracao-rishikesh/deluxe',
                details: [
                    "1 King Size Bed",
                    "Up to 2 Guests",
                    "21 sq.mt",
                ],
            },
        ],

        allRoom: { link: "/resort-de-coracao-rishikesh/room-listing" }
    }

    return (
        <>
            <Subheader subheadData={subheadData} />
            <RoomBanner roomBanner={roomBanner} />
            <RoomQuote roomQuote={roomQuote} />
            <RoomCount roomCount={roomCount} />
            <RoomGallery roomGallery={roomGallery} />
            <RoomEquipment roomEquipment={roomEquipment} />
            <RoomBook roomBook={roomBook} />
            <OtherRoom otherRoom={otherRoom} roomTitle={`${roomBook.location} ${subheadData.heading}`}/>
        </>
    )
}
